export type MapDensity = "normal" | "compact";

export const MAP_COMFORT_COLUMNS = 5;
export const MAP_ROW_HEIGHT = 64;
export const MAP_COMPACT_ROW_HEIGHT = 56;

export function mapDensity(columns: number): MapDensity {
  return columns > MAP_COMFORT_COLUMNS ? "compact" : "normal";
}

export function mapRowHeight(density: MapDensity): number {
  return density === "compact" ? MAP_COMPACT_ROW_HEIGHT : MAP_ROW_HEIGHT;
}

export function mapGridTemplateColumns(columns: number): string {
  return `repeat(${columns}, minmax(0, 1fr))`;
}

export function mapCanvasHeight(totalRows: number, density: MapDensity = "normal"): number {
  return totalRows * mapRowHeight(density);
}
